import type { SecuritiesContextProps } from '@talos/kyoko';
import type { FeatureFlags } from '../../../hooks/useFeatureFlag';

export interface OptionsTradingAccessConditions {
  flags: Pick<FeatureFlags, 'enableOptionsChainView'>;
  securities: Pick<SecuritiesContextProps, 'options'>;
}

export function hasOptionsTradingAccess({ flags, securities }: OptionsTradingAccessConditions) {
  return securities.options.length > 0 && flags.enableOptionsChainView;
}
